<script lang="ts">
    import { Link } from '../../../modules/toolsApi/sites/links/link'
    import { LinksType } from '../../../modules/toolsApi/sites/links/link.enum'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    export let link: Link = new Link()
    // opção vazia explícita: sem ela o select fica sem seleção visível enquanto o tipo está vazio
    const typeOptions = [{ value: '', label: '' }, ...Object.values(LinksType).map((type) => ({ value: type, label: type }))]

    function sendSuccess() {
        if (!link.type || !link.title || !link.url) {
            window.error('Informe todos os dados')
            return
        }
        if (link.type === LinksType.email) {
            link.url = link.url.toLocaleLowerCase()
            if (!link.url.includes('@')) {
                window.error('E-mail inválido')
                return
            }
        }
        if (link.type === LinksType.facebook) {
            if (!link.url.startsWith('https://')) {
                window.error('Endereço de perfil inválido')
                return
            }
        }
        if (link.type === LinksType.gps) {
            if (link.url.includes('http') || !link.url.includes(',') || link.url.length < 10) {
                window.error('Endereço inválido')
                return
            }
        }
        if (link.type === LinksType.instagram) {
            if (!link.url.startsWith('@')) {
                window.error('Endereço de perfil inválido')
                return
            }
        }
        if (link.type === LinksType.link) {
            if (!link.url.startsWith('http')) {
                window.error('Link inválido')
                return
            }
        }
        if (link.type === LinksType.phone) {
            link.url = window.api.utils.utils.phoneSanitize(link.url)
            if (link.url.length < 10) {
                window.error('Telefone inválido')
                return
            }
            link.url = window.api.utils.utils.phoneNormalize(link.url, '00')
        }
        if (link.type === LinksType.tiktok) {
            if (!link.url.startsWith('@')) {
                window.error('Endereço de perfil inválido')
                return
            }
        }
        if (link.type === LinksType.whatsapp) {
            link.url = window.api.utils.utils.phoneSanitize(link.url)
            if (link.url.length < 10) {
                window.error('Telefone inválido')
                return
            }
            link.url = window.api.utils.utils.phoneNormalize(link.url, '00')
        }
        if (link.type === LinksType.youtube) {
            if (!link.url.startsWith('https://')) {
                window.error('Endereço de perfil inválido')
                return
            }
        }
        dispatch('success', link)
    }

    $: {
        setLabel(link.type)
    }

    let label = 'Link https://'
    let help = ''
    function setLabel(type: LinksType) {
        switch (link.type) {
            case LinksType.email:
                label = 'E-Mail'
                help = ''
                break
            case LinksType.gps:
                label = 'Endereço'
                help = 'Separe apenas por vírgula. Siga este padrão: Rua Principal, 2300, Centro, São Paulo, SP'
                break
            case LinksType.facebook:
                label = 'Facebook'
                help = 'Deve começar com https://'
                break
            case LinksType.instagram:
                label = 'Instagram'
                help = 'Apenas a arroba. Deve começar com @'
                break
            case LinksType.phone:
                label = 'Telefone'
                help = 'Inclua o DDD. Ex.: (11)91010-2020'
                break
            case LinksType.tiktok:
                label = 'TikTok'
                help = 'Apenas a arroba. Deve começar com @'
                break
            case LinksType.whatsapp:
                label = 'WhatsApp'
                help = 'Inclua o DDD. Ex.: (11)91010-2020'
                break
            case LinksType.youtube:
                label = 'YouTube'
                help = 'Inclua o endereço completo. Deve começar com https://'
                break
            default:
                label = 'Link'
                help = 'Deve começar com http:// ou https://'
                break
        }
    }
</script>

<div class="root">
    <Zact>
        <div class="spacer" />
        <Zbutton color="primary" icon={faSave} label="Salvar" on:click={sendSuccess} />
    </Zact>
    <Zframe class="m-3" title="Link">
        <ZContainer gapRow="8px" gapCol="8px">
            <Zinput size={12} label="Tipo" type="select" options={typeOptions} bind:value={link.type} />
            <Zinput size={12} label="Título" type="text" bind:value={link.title} />
            <Zinput size={12} {label} type="text" bind:value={link.url} />
            {#if help}
                <ZContainerCol size={12}>
                    <div class="text-muted">{help}</div>
                </ZContainerCol>
            {/if}
        </ZContainer>
    </Zframe>
</div>
